import axios from 'axios';
const URL = "https://api.glas.com.br:213";
const api = axios.create({
    baseURL: URL,
    auth: {
        username: "infotec",
        password: "inf*251270"
    } 
    
});
export default api;